export const SPACING_PADDING_TOP = 28;
export const HEADER_HEIGHT = 77;
